/* eslint-disable */
import React, { useState } from 'react';

const card = { background:'#fff', border:'0.5px solid rgba(0,0,0,0.07)', borderRadius:'12px', boxShadow:'0 1px 3px rgba(0,0,0,0.05)' };

const CONNECTORS = [
  { name:'API REST v2',     status:'actif',   color:'#1A7A4A', last:'il y a 2 min', vol:'348 req/j' },
  { name:'Airtable sync',   status:'actif',   color:'#1A7A4A', last:'il y a 8 min', vol:'201 sync/j' },
  { name:'Webhook sortant', status:'actif',   color:'#1A7A4A', last:'il y a 1 min', vol:'623 events' },
  { name:'Mail parser',     status:'dégradé', color:'#d97706', last:'il y a 1h',    vol:'74 emails/j' },
];

const LOGS = [
  { method:'POST', path:'/api/dossiers',           status:201, label:'Created',     time:'il y a 2 min',  color:'#1A7A4A' },
  { method:'POST', path:'/api/dossiers',           status:201, label:'Created',     time:'il y a 3 min',  color:'#1A7A4A' },
  { method:'GET',  path:'/api/dossiers?limit=50',  status:200, label:'OK',          time:'il y a 5 min',  color:'#1A7A4A' },
  { method:'POST', path:'/api/dossiers',           status:400, label:'Bad Request', time:'il y a 12 min', color:'#B03020' },
  { method:'POST', path:'/webhooks/airtable',      status:200, label:'OK',          time:'il y a 15 min', color:'#1A7A4A' },
];

export default function Developpeurs() {
  const [showKey, setShowKey] = useState(false);

  return (
    <div>
      <div style={{ marginBottom:'1.5rem' }}>
        <div style={{ fontFamily:'Syne, sans-serif', fontSize:'18px', fontWeight:600, color:'#1A1916' }}>Développeurs & API</div>
        <div style={{ fontSize:'12px', color:'rgba(26,25,22,0.4)', marginTop:'2px' }}>API keys · Webhooks · Logs · Connecteurs</div>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'1rem', marginBottom:'1rem' }}>
        <div style={{ ...card, padding:'1.1rem 1.3rem' }}>
          <div style={{ fontFamily:'Syne, sans-serif', fontSize:'13px', fontWeight:600, color:'#1A1916', marginBottom:'1rem' }}>API Keys</div>
          <div style={{ background:'#F0EDE5', border:'0.5px solid rgba(0,0,0,0.08)', borderRadius:'8px', padding:'10px 14px', fontFamily:'monospace', fontSize:'12px', color:'rgba(26,25,22,0.7)', marginBottom:'10px', letterSpacing:'0.03em' }}>
            {showKey ? 'lx_live_a8f3d2c1e9b4f7a2d5c8e1f4a7b0c3d6' : 'lx_live_••••••••••••••••••••••••••••••••'}
          </div>
          <div style={{ display:'flex', gap:'8px' }}>
            <button onClick={() => setShowKey(v => !v)} style={{ fontSize:'11px', background:'rgba(26,85,160,0.08)', color:'#1A55A0', border:'0.5px solid rgba(26,85,160,0.2)', borderRadius:'6px', padding:'5px 12px', cursor:'pointer', fontFamily:'DM Sans, sans-serif' }}>
              {showKey ? 'Masquer' : 'Révéler'}
            </button>
            <button style={{ fontSize:'11px', background:'rgba(176,48,32,0.06)', color:'#B03020', border:'0.5px solid rgba(176,48,32,0.2)', borderRadius:'6px', padding:'5px 12px', cursor:'pointer', fontFamily:'DM Sans, sans-serif' }}>
              Régénérer
            </button>
          </div>
          <div style={{ marginTop:'1rem', paddingTop:'12px', borderTop:'0.5px solid rgba(0,0,0,0.06)' }}>
            <div style={{ fontSize:'10px', textTransform:'uppercase', letterSpacing:'0.07em', color:'rgba(26,25,22,0.35)', marginBottom:'6px' }}>Documentation API</div>
            <a href="https://docs.lexback.fr/api" target="_blank" rel="noreferrer" style={{ fontSize:'12px', color:'#1A55A0', textDecoration:'none', fontWeight:500 }}>
              docs.lexback.fr/api →
            </a>
          </div>
        </div>

        <div style={{ ...card, padding:'1.1rem 1.3rem' }}>
          <div style={{ fontFamily:'Syne, sans-serif', fontSize:'13px', fontWeight:600, color:'#1A1916', marginBottom:'1rem' }}>Connecteurs actifs</div>
          {CONNECTORS.map((c, i) => (
            <div key={c.name} style={{ display:'flex', alignItems:'center', gap:'10px', padding:'8px 0', borderBottom:i < CONNECTORS.length-1 ? '0.5px solid rgba(0,0,0,0.05)':'none' }}>
              <div style={{ width:'7px', height:'7px', borderRadius:'50%', background:c.color, flexShrink:0 }} />
              <div style={{ flex:1 }}>
                <div style={{ fontSize:'12px', color:'#1A1916' }}>{c.name}</div>
                <div style={{ fontSize:'10px', color:'rgba(26,25,22,0.38)', marginTop:'1px' }}>{c.last} · {c.vol}</div>
              </div>
              <span style={{ fontSize:'11px', fontWeight:500, color:c.color }}>● {c.status}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{ ...card, overflow:'hidden' }}>
        <div style={{ padding:'12px 16px', borderBottom:'0.5px solid rgba(0,0,0,0.06)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div style={{ fontFamily:'Syne, sans-serif', fontSize:'13px', fontWeight:600, color:'#1A1916' }}>Logs récents</div>
          <button style={{ background:'transparent', border:'none', fontSize:'12px', color:'#1A55A0', cursor:'pointer', fontFamily:'DM Sans, sans-serif' }}>Voir tous →</button>
        </div>
        <div style={{ padding:'6px 0' }}>
          {LOGS.map((log, i) => (
            <div key={i} style={{ display:'flex', alignItems:'center', gap:'16px', padding:'8px 16px', borderBottom:i < LOGS.length-1 ? '0.5px solid rgba(0,0,0,0.04)':'none', fontFamily:'monospace' }}
              onMouseEnter={e => e.currentTarget.style.background='#F5F3EE'}
              onMouseLeave={e => e.currentTarget.style.background='transparent'}
            >
              <div style={{ fontSize:'11px', color:'rgba(26,25,22,0.45)', width:'38px', flexShrink:0 }}>{log.method}</div>
              <div style={{ fontSize:'11px', color:'rgba(26,25,22,0.65)', flex:1 }}>{log.path}</div>
              <div style={{ fontSize:'11px', fontWeight:500, color:log.color, width:'110px' }}>{log.status} {log.label}</div>
              <div style={{ fontSize:'11px', color:'rgba(26,25,22,0.35)', width:'90px', textAlign:'right' }}>{log.time}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
